import { Component } from "react";
import Link from "next/link";
import ErrorPage from "next/error";
import Head from "next/head";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import flowRight from "lodash/flowRight";
import { bindActionCreators } from "redux";
import { injectIntl, FormattedMessage } from "react-intl";
import cache from "memory-cache";

import { Container } from "reactstrap";

import {
  Background,
  Loading,
  Header,
  DatesListing,
  EventsListing,
  HeaderSocialIcon,
  Menu,
} from "components/index";

import {
  makeSelectCurOrg,
  makeSelectLoading as makeSelectLoadingOrg,
} from "logic/orgs";

import { fetchDates } from "logic/dates";

import messages from "i18n/messages";

const CompanyLogo = ({ url }) => (
  <div className="company-logo" style={{ backgroundImage: `url(${url})` }} />
);

class Index extends Component {
  // we want this to be rendered on client side only
  componentDidMount() {
    const { org } = this.props;
    if (!org) return;

    this.props.actions.fetchDates(org.id, null, org.allow_exceeding_dates);
  }

  // static async getInitialProps(ctx) {
  //   const url = `/orgs/odn/${ctx.query.odn}`;
  //   const org = cache.get(url);
  //   this.props.actions.fetchDates(org.id, null, org.allow_exceeding_dates);
  // }

  render() {
    const {
      org,
      loading,
      intl: { formatMessage },
    } = this.props;
    if (!org && loading) return <Loading />;
    if (!org) return <ErrorPage statusCode={404} />;

    return (
      <div>
        <Menu orgHeader={false} />
        <Head>
          <title>{`${formatMessage(messages.ticketShop, org)}`}</title>
          <meta
            name="description"
            content={`${formatMessage(messages.buyTicketsFor, org)}`}
          />
          <meta
            property="og:description"
            content={`${formatMessage(messages.buyTicketsFor, org)}`}
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content={`${formatMessage(messages.ticketShop, org)}`}
          />
          <meta property="og:image" content={org.bg_img.full} />
          <meta name="twitter:card" content="summary" />
          <meta
            name="twitter:site"
            content={org.social.twitter_user || undefined}
          />
          <meta
            name="twitter:creator"
            content={org.social.twitter_user || undefined}
          />
          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Head>
        <Background imgSrc={org.bg_img.full} />
        <Container className="tt-content-wrap">
          <Header imgSrc={org.bg_img.full}>
            <div className="tt-header-title">
              {org.logo.full ? <CompanyLogo url={org.logo.full} /> : null}
              <h1>{org.name}</h1>
              <small>{org.subtitle}</small>
              <div dangerouslySetInnerHTML={{ __html: org.description }} />
            </div>
            <div className="tt-org-info">
              <div className="small-title">
                <FormattedMessage {...messages.address} />
              </div>
              <p>
                {org.addr.street}
                <br />
                {org.addr.postcode} {org.addr.city}
              </p>
              <div className="small-title">
                <FormattedMessage {...messages.web} />
              </div>
              <a href={org.addr.web}>{org.addr.web}</a>
            </div>
            <div className="tt-header-social-icons">
              {org.addr.email ? (
                <HeaderSocialIcon
                  icon="tt-icon-email"
                  link={`mailto:${org.addr.email}`}
                  tooltip={org.addr.email}
                />
              ) : null}
              {org.social.facebook_page ? (
                <HeaderSocialIcon
                  icon="tt-icon-logo-fb-simple-2"
                  link={`https://facebook.com/${org.social.facebook_page}`}
                  tooltip={`/${org.social.facebook_page}`}
                />
              ) : null}
              {org.social.twitter_user ? (
                <HeaderSocialIcon
                  icon="tt-icon-logo-twitter-2"
                  link={`https://twitter.com/${org.social.twitter_user}`}
                  tooltip={`/${org.social.twitter_user}`}
                />
              ) : null}
            </div>
          </Header>
          <div className="tt-content with-sidenav">
            <div className="tt-content-inner">
              {org.portal.show_programme ? (
                <DatesListing showMore={true} />
              ) : (
                <EventsListing />
              )}
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  loading: makeSelectLoadingOrg(),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchDates,
    },
    dispatch
  ),
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(Index);
